import { getMerchantSharedSettingsComplete, GetMerchantSharedSettingsRequestAction } from "actions/merchant";
import { MERCHANT } from "constants/action-types";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { Observable } from "rxjs";

export const getMerchantDefaultSharedSettingsEpic = (
    action$: ActionsObservable<GetMerchantSharedSettingsRequestAction>
) =>
    action$
        .ofType(MERCHANT.SHARED_SETTINGS.GET.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId }) => {
            return ajax(`${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/merchant_shared_settings`)
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }
                    return [getMerchantSharedSettingsComplete(response)];
                })
                .catch((error) => Observable.merge(Observable.of(getMerchantSharedSettingsComplete(error))));
        });
